/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-03.
 */
import React, { Component } from 'react';

class Expenses extends Component {
    render() {
        const {
            subtotal = 0,
            tax = 0,
            aditionalTax = 0,
            retentions = 0,
            total = 0,
            preInvoiceTypeConfig
        } = this.props;
        const {
            tax: showTax,
            aditionalTax: showAdditionalTax,
            retentions: showRetentions,
        } = preInvoiceTypeConfig;


        return (
            <div>
                <div className="display-flex-center margin-top-2">
                    <div className="col-md-3 col-xs-12 display-flex-center" />
                    <div className="col-md-2 col-xs-12 display-flex-center" />
                    <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end" />
                    <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end pr0"><p className="text-bold text-color-light">Subtotal</p></div>
                    <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">{subtotal.formatMoney()}</div>
                </div>
                {
                    showTax && <div className="display-flex-center margin-top-1">
                        <div className="col-md-3 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end pr0"><p className="text-bold text-color-light">IVA</p></div>
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">{tax.formatMoney()}</div>
                    </div>
                }
                {
                    showAdditionalTax && <div className="display-flex-center margin-top-1">
                        <div className="col-md-3 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end pr0"><p className="text-bold text-color-light">IVA Flete</p></div>
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">{aditionalTax.formatMoney()}</div>
                    </div>
                }
                {
                    showRetentions && <div className="display-flex-center margin-top-1">
                        <div className="col-md-3 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end pr0"><p className="text-bold text-color-light">Retencion Flete</p></div>
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">{retentions.formatMoney()}</div>
                    </div>
                }
                <div className="display-flex-center margin-top-1">
                    <div className="col-md-3 col-xs-12 display-flex-center" />
                    <div className="col-md-2 col-xs-12 display-flex-center" />
                    <div className="col-md-1 col-xs-12 display-flex-center display-flex-just-end" />
                    <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end pr0"><p className="text-bold text-color-light">Total gastos por despacho aduanero</p></div>
                    <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">{total.formatMoney()}</div>
                </div>
            </div>
        );
    }
}

export default Expenses;



// WEBPACK FOOTER //
// ./forms/customPrefactura/expenses.js